<template>
  <BasePaneCard
    heading="CSAT"
    :tray="answerRate"
    :isLoading="isLoading"
  >
    <div class="csat-review">
      <template v-if="dataset">
        <div
          class="widget-csat-review"
          :class="{ 'widget-csat-review--disabled': isAppliedPageFilter(['csat']) }"
        >
          <div
            v-if="!isAppliedPageFilter(['csat'])"
            class="widget-csat-review__score"
          >
            <div
              class="widget-csat-review__score__bar"
            />

            <div class="widget-csat-review__score__inner">
              <p class="widget-csat-review__score__text">
                Nível de satisfação
              </p>

              <span
                class="widget-csat-review__score__total"
                :class="{ 'widget-csat-review__score__total--long': score > 99 }"
              >
                {{ dataset?.csatScoreData?.metrics[0]?.csat | percentage('integer') }}
              </span>
            </div>
          </div>

          <div class="widget-csat-review__metrics">
            <div class="widget-csat-review__rating-container">
              <div
                v-for="item in filteredEvaluation"
                :key="item.evaluation"
                class="widget-csat-review__row"
              >
                <div class="widget-csat-review__star-container">
                  <SvgIconStar />

                  <span class="widget-csat-review__star-number">
                    {{ item.evaluation }}
                  </span>
                </div>

                <div
                  v-tooltip="{
                    theme: 'tooltip-top-left',
                    content: item.percentage ? item.percentage + '%' : 'Sem avaliações'
                  }"
                  class="widget-csat-review__progress-bar-track"
                >
                  <div
                    v-if="!isAppliedPageFilter(['csat']) || isAppliedPageFilter(['csat'], [item.evaluation])"
                    class="widget-csat-review__progress-bar-fill"
                    :style="`width: ${item.percentage}%;`"
                  />

                  <div
                    v-else
                    class="widget-csat-review__progress-bar-fill"
                    :style="`width: 0%;`"
                  />
                </div>

                <div class="widget-csat-review__star-percentage">
                  <template v-if="!isAppliedPageFilter(['csat']) || isAppliedPageFilter(['csat'], [item.evaluation])">
                    {{ item.amount | number }}
                  </template>

                  <template v-else>
                    -
                  </template>
                </div>

                <div class="button-lead-conversations">
                  <button
                    v-tooltip="{
                      theme: 'tooltip-left',
                      content: 'Abrir lista<br>de conversas.'
                    }"
                    @click.prevent="openLeadConversations(item.evaluation)"
                  >
                    <SvgIconChat/>
                  </button>
                </div>
              </div>
            </div>

            <div class="widget-csat-review__answers">
              <div>
                {{ dataset?.csatScoreData?.metrics[0]?.total_answered | number }}

                <span class="widget-csat-review__answers__text">
                  respostas
                </span>
              </div>

              <SvgIconInfo
                v-tooltip="{
                  theme: 'tooltip-left',
                  content: 'O CSAT é enviado após a finalização<br>de uma conversão ou recusa'
                }"
                class="widget-csat-review__answers__icon"
              />
            </div>
          </div>
        </div>

        <div class="widget-csat-divider"/>

        <div class="widget-csat-comments">
          <span class="widget-csat-comments__title">Avaliações</span>

          <div
            v-if="dataset?.csatComments?.length"
            class="widget-csat-comments__container"
          >
            <template v-for="(item, i) in dataset?.csatComments">
              <div
                :key="item.id_lead_history"
                class="csat-comment"
              >
                <div class="csat-comment__details">
                  <div class="csat-comment__details__header">
                    <div class="csat-comment__details__header__name">
                      {{ item.name | startCase }}
                    </div>

                    <div class="csat-comment__details__header__rating">
                      <div class="widget-csat-comments__star-icon">
                        <SvgIconStar
                          v-for="(i, index) in item.evaluation"
                          :key="'star-' + index"
                          class="widget-csat-comments__star-icon--active"
                        />

                        <SvgIconStarOutline
                          v-for="(j, index) in (5 - item.evaluation)"
                          :key="'star-outline-' + index"
                          class="widget-csat-comments__star-icon--inactive"
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="item.details"
                    class="csat-comment__details__message"
                  >
                    {{ item.details }}
                  </div>

                  <div class="csat-comment__details__when">
                    Finalizado em&nbsp;{{ item.date | date('datetime-small') }}
                  </div>
                </div>

                <div class="csat-comment__action">
                  <button
                    class="button-lead-history"
                    v-tooltip="{
                      theme: 'tooltip-left',
                      content: 'Abrir lista<br>de conversas.'
                    }"
                    @click.prevent="openLeadHistory(item)"
                  >
                    <SvgIconChat/>
                  </button>
                </div>
              </div>

              <div
                v-if="i < dataset.csatComments.length - 1"
                :key="`${item.id_lead_history}-divider`"
                class="widget-csat-divider"
              />
            </template>
          </div>

          <BaseEmptyState
            v-else
            class="widget-csat-empty-state"
          >
            <template v-if="isNotApplicableStatusFilter">
              <SvgIconStarsOutline/>

              <h3>
                As conversas filtradas por este<br>
                status ainda não possuem avaliação.
              </h3>
            </template>

            <template v-else>
              <SvgIconStarsOutline/>

              <h3>
                Nenhuma avaliação<br>
                disponível na data escolhida
              </h3>
            </template>
          </BaseEmptyState>
        </div>
      </template>

      <template v-else>
        <div class="widget-csat-review">
          <div class="widget-csat-review__score">
            <div class="widget-csat-review__score__bar"/>

            <div class="widget-csat-review__score__inner">
              <div class="widget-csat-review__score__total">
                <template>
                  {{ 0 | percentage('integer') }}
                </template>
              </div>
            </div>
          </div>

          <div class="widget-csat-review__metrics">
            <div class="widget-csat-review__rating-container">
              <div
                v-for="i in 5"
                :key="i"
                class="widget-csat-review__row"
              >
                <div class="widget-csat-review__star-container">
                  <SvgIconStar />

                  <span class="widget-csat-review__star-number">
                    {{ i }}
                  </span>
                </div>

                <div
                  v-tooltip="{
                    theme: 'tooltip-top-left',
                    content: 'Sem avaliações'
                  }"
                  class="widget-csat-review__progress-bar-track"
                >
                  <div
                    class="widget-csat-review__progress-bar-fill"
                    :style="`width: ${0}%;`"
                  />
                </div>

                <div class="widget-csat-review__star-percentage">
                  {{ 0 | number }}
                </div>

                <div class="button-lead-conversations button-lead-conversations--disabled">
                  <button>
                    <SvgIconChat/>
                  </button>
                </div>
              </div>
            </div>

            <div class="widget-csat-review__answers">
              <div>
                {{ 0 | number }}

                <span class="widget-csat-review__answers__text">
                  respostas
                </span>
              </div>

              <SvgIconInfo class="widget-csat-review__answers__icon"/>
            </div>
          </div>
        </div>

        <div class="widget-csat-divider"/>

        <div class="widget-csat-comments">
          <span class="widget-csat-comments__title">
            Avaliações
          </span>

          <BaseEmptyState class="widget-csat-empty-state widget-csat-empty-state--disabled">
            <SvgIconRunningWithErrors/>

            <h3>Ocorreu um erro inesperado.</h3>

            <p>Atualize a página. Se o erro persistir,<br>entre em contato conosco.</p>
          </BaseEmptyState>
        </div>
      </template>
    </div>

    <CommonLeadConversations
      :isOpen="isOpenLeadConversations"
      :heading="leadConversationsHeading"
      :urlParams="leadConversations.urlParams"
    />

    <CommonLeadHistory
      :isOpen="isOpenLeadHistory"
      :heading="leadHistoryHeading"
      :subheading="leadHistorySubheading"
      :leadId="leadSelected.id"
      :historyId="leadSelected.historyId"
    />
  </BasePaneCard>
</template>

<script>
import { numberFilter, percentageFilter, dateFilter, startCaseFilter } from '@/utils/filters'
import { pageFilterExceptionMixin } from '@/utils/mixins'
import BasePaneCard from '@/components/base/BasePaneCard'
import BaseEmptyState from '@/components/base/BaseEmptyState'
import CommonLeadConversations from '@/components/common/CommonLeadConversations'
import CommonLeadHistory from '@/components/common/CommonLeadHistory'
import { mapState, mapGetters, mapMutations } from 'vuex'
import axios from 'axios'
import ProgressBar from 'progressbar.js'
import dayjs from 'dayjs'

export default {
  name: 'WidgetCsatReview',

  components: {
    BasePaneCard,
    BaseEmptyState,
    CommonLeadConversations,
    CommonLeadHistory
  },

  filters: {
    number: numberFilter,
    percentage: percentageFilter,
    date: dateFilter,
    startCase: startCaseFilter
  },

  mixins: [
    pageFilterExceptionMixin
  ],

  data () {
    return {
      isLoading: false,
      dataset: null,
      progressBar: null,
      isOpenLeadConversations: false,
      leadConversations: {
        filter: 'csat',
        key: '',
        urlParams: ''
      },
      isOpenLeadHistory: false,
      leadSelected: {
        id: null,
        historyId: null,
        name: null
      }
    }
  },

  computed: {
    ...mapState('base', [
      'mainApi',
      'pageFilter'
    ]),

    ...mapGetters('auth', [
      'userId',
      'platformId'
    ]),

    ...mapGetters('base', ['isAppliedPageFilter']),

    answerRate () {
      return this.dataset?.csatScoreData?.metrics[0]?.answer_rate
        ? `Taxa de resposta ${percentageFilter(this.dataset.csatScoreData.metrics[0].answer_rate, 'integer')}`
        : 'Sem taxa de resposta'
    },

    score () {
      let score = 0

      if (this.dataset?.csatScoreData?.metrics[0]?.csat) {
        score = this.dataset?.csatScoreData?.metrics[0]?.csat
      }

      return Math.round(score)
    },

    leadConversationsHeading () {
      const { key } = this.leadConversations

      return key ? `CSAT ${key}` : ''
    },

    leadHistoryHeading () {
      const { name } = this.leadSelected

      return name
        ? startCaseFilter(name)
        : ''
    },

    leadHistorySubheading () {
      const { id } = this.leadSelected

      return id
        ? `ID #${id}`
        : ''
    },

    filteredEvaluation() {
      if (!this.isAppliedPageFilter(['csat'])) {
        return this.dataset?.csatScoreData?.evaluation;
      }

      return this.dataset?.csatScoreData?.evaluation.filter(e => this.isAppliedPageFilter(['csat'], [e.evaluation]));
    },

    isNotApplicableStatusFilter () {
      return this.pageFilter?.status?.length && !(
        this.pageFilter?.status?.includes(3) ||
        this.pageFilter?.status?.includes(16)
      )
    }
  },

  watch: {
    pageFilter () {
      this.dataset = null
      this.fetchData()
    },

    dataset () {
      this.initProgressBar(this.score / 100)
    }
  },

  mounted () {
    this.$root.$on('pane-tray-close', this.closeLeadConversations)
    this.$root.$on('pane-tray-close', this.closeLeadHistory)

    this.fetchData()
    this.initProgressBar(this.score / 100)
  },

  beforeDestroy () {
    this.destroyProgressBar()
  },

  methods: {
    ...mapMutations('smartSummary', {
      setCsat: 'SET_CSAT'
    }),

    getFetchDataParams (leadConversationsMode) {
      let params = ''
      let [dateStart, dateEnd] = this.pageFilter.dateRange
      const { action, csat, feeling, status } = this.pageFilter

      if (!dateStart || !dateEnd) {
        dateStart = dayjs()
        dateEnd = dateStart.add(1, 'day')
      }

      if (leadConversationsMode) {
        params += '?'

        params += `&filter=${this.leadConversations.filter}`
        params += `&key=${this.leadConversations.key}`

        params += `&firstDate=${dateFilter(dateStart, 'base')}`
        params += `&lastDate=${dateFilter(dateEnd, 'base')}`

        if (action.length) {
          params += `&actions=${action.join()}`
        }

        if (feeling.length) {
          params += `&sentiments=${feeling.join()}`
        }

        if (status.length) {
          params += `&status=${status.join()}`
        }
      } else {
        params += `/date/${dateFilter(dateStart, 'base')}/${dateFilter(dateEnd, 'base')}`

        if (action) {
          params += `/action/${action.join()}`
        }

        params += '?'

        if (csat.length) {
          params += `&csat=${csat.join()}`
        }

        if (feeling.length) {
          params += `&sentiments=${feeling.join()}`
        }

        if (status.length) {
          params += `&status=${status.join()}`
        }
      }

      return params
        .replace(/\?$/, '')
        .replace(/\?&/, '?')
    },

    async fetchData () {
      this.isLoading = true

      try {
        const params = this.getFetchDataParams()
        const metricUrl = `${this.mainApi}lead/widget-csat/evaluation/metrics${params.replace(/date\/|action\//g, '')}`
        const evaluationUrl = `${this.mainApi}lead/widget-csat/evaluation${params}`

        await axios
          .all([
            axios.get(metricUrl),
            axios.get(evaluationUrl)
          ])
          .then(axios.spread((
            { data: metricResponse },
            { data: evaluationResponse }
          ) => {
            this.dataset = {
              csatScoreData: metricResponse,
              csatComments: evaluationResponse
            }

            this.setCsat({ 
              answer_rate: this.dataset.csatScoreData.metrics[0].answer_rate,
              score: this.dataset.csatScoreData.metrics[0].csat,
              total_answered: this.dataset.csatScoreData.metrics[0].total_answered
            })
          }))
      } catch (error) {
        this.dataset = null

        throw error
      } finally {
        this.isLoading = false
      }
    },

    initProgressBar (progress) {
      this.destroyProgressBar()

      this.$nextTick(() => {
        const container = document.querySelector('.widget-csat-review__score__bar')
        const options = {
          duration: 300,
          easing: 'easeInOut',
          strokeWidth: 7,
          color: '#98c1dd',
          trailColor: '#e2ebf0',
          svgStyle: null
        }

        this.progressBar = new ProgressBar.Circle(container, options)

        this.progressBar.animate(progress)
      })
    },

    destroyProgressBar () {
      if (this.progressBar) {
        this.progressBar.destroy()

        this.progressBar = null
      }
    },

    updateLeadConversations (key) {
      this.leadConversations.key = key
      this.leadConversations.urlParams = this.getFetchDataParams(true)
    },

    openLeadConversations (key) {
      this.$root.$emit('pane-tray-close', 'leadConversationsContext')

      this.updateLeadConversations(key)

      this.isOpenLeadConversations = true
    },

    closeLeadConversations (context) {
      if (context === 'leadConversationsContext') {
        this.isOpenLeadConversations = false
      }
    },

    selectLead (lead) {
      const {
        fk_id_lead: id,
        id_lead_history: historyId,
        name
      } = lead

      this.leadSelected = {
        id,
        historyId,
        name
      }
    },

    openLeadHistory (lead) {
      this.selectLead(lead)

      this.isOpenLeadHistory = true
    },

    closeLeadHistory () {
      this.isOpenLeadHistory = false
    }
  }
}
</script>

<style lang="scss" scoped>
$blue-dark: nth($colors-custom, 1);
$blue-light: nth($colors-custom, 2);
$blue-light-2: nth($colors-custom, 7);
$gray-light: nth($colors-custom, 4);
$gray-dark: nth($colors-custom, 15);

.csat-review {
  height: 440px;
  display: grid;
  grid-template-rows: max-content max-content minmax(0, 1fr);
}

.widget-csat-review {
  display: grid;
  text-align: center;
  grid-template-columns: 1fr minmax(0, 3fr);
  gap: 24px;
  margin-bottom: 12px;
  align-items: center;

  &--disabled {
    grid-template-columns: 1fr;
  }

  &__score {
    position: relative;
    width: 130px;
    height: 130px;

    &__bar {
      z-index: 10;
      position: relative;
      height: 100%;

      /deep/ {
        svg {
          width: 100%;
          height: 100%;
          stroke-linecap: round;
        }
      }
    }

    &__inner {
      z-index: 9;
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
      border: 16px solid #fff;
      border-radius: 100%;
      background: linear-gradient(199deg, rgba(152, 193, 221, 0.20) 31.94%, rgba(152, 193, 221, 0.00) 90.73%);
      filter: drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.05));
      display: flex;
      flex-direction: column;
      text-align: center;
      gap: 4px;
      font: {
        weight: 500;
        size: 24px;
      }
    }

    &__text {
      font: {
        weight: 400;
        size: 13px;
      }
      line-height: 14px;
    }

    &__total {
      font: {
        weight: 700;
        size: 30px;
      }
      line-height: 25px;
      letter-spacing: 1.5px;

      &--long {
        font-size: 25px;
        letter-spacing: -1.25px;
      }
    }
  }

  &__metrics {
    display: flex;
    flex-direction: column;
  }

  &__row {
    display: grid;
    grid-template-columns: max-content minmax(100px, 1fr) 24px max-content;
    gap: 10px;
    place-items: center;
  }

  &__star-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__star-number {
    font: {
      size: 12px;
      weight: 700;
    }
    line-height: 16px;
  }

  &__progress-bar-track {
    height: 8px;
    background-color: $gray-light;
    border-radius: 8px;
    width: 100%;
  }

  &__progress-bar-fill {
    height: 8px;
    background-color: $blue-light;
    border-radius: 8px;
    transition: width 0.3s ease-in-out;
  }

  &__star-percentage {
    font: {
      size: 12px;
      weight: 600;
    }
  }

  &__answers {
    display: flex;
    justify-content: end;
    align-items: center;
    gap: 8px;
    margin: 5px 0 0 0;
    font: {
      size: 12px;
      weight: 600;
    }

    &__text {
      font: {
        weight: 500;
      }
    }

    &__icon {
      width: 10px;
      height: 10px;
    }
  }
}

.widget-csat-divider {
  min-height: 2px;
  width: 100%;
  border-radius: 2px;
  background: $gray-light;
  opacity: 0.5;
}

.widget-csat-comments {
  @extend %scrollbar;
  margin-top: 20px;
  margin-bottom: 25px;

  &__title {
    font: {
      size: 16px;
      weight: 600;
    }
    line-height: 22px;
    color: $blue-light;
  }

  &__container {
    padding-right: 15px;
    overflow-y: auto;
    max-height: 100%;
    margin-top: 8px;
  }

  &__star-icon {
    &--active {
      width: 15px;
      height: 13px;
      fill: $blue-light;
    }

    &--inactive {
      margin: 1px 0 0 1px;
      width: 15px;
      transform: scale(1.2);
    }
  }
}

.button-lead-conversations {
  display: flex;
  justify-content: flex-end;

  &--disabled {
    button {
      svg {
        fill: $gray-dark !important;
      }
    }
  }

  button {
    width: 16px;
    padding: 0;
    border: 0;
    background: none;

    &:hover {
      svg {
        fill: $blue-light;
      }
    }

    svg {
      transition: all 0.1s;
      fill: $blue-dark;
    }
  }
}

.button-lead-history {
  display: flex;
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
  border: 1px solid nth($colors-custom, 1);
  border-radius: 100%;
  transition: all 0.1s;
  background: none;

  &:hover {
    border-color: nth($colors-custom, 2);
    color: nth($colors-custom, 2);

    svg {
      fill: nth($colors-custom, 2);
    }
  }

  svg {
    width: 14px;
    transition: all 0.1s;
    fill: nth($colors-custom, 1);
  }
}

.csat-comment {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  padding: 8px 0;

  &__details {
    &__header {
      display: flex;
      gap: 15px;

      &__name {
        font: {
          weight: 600;
          size: 14px;
        }
        line-height: 120%;
      }

      &__rating {
        transform: translateY(-5px);
        white-space: nowrap;
      }
    }

    &__message {
      font-size: 12px;
      line-height: 140%;
    }

    &__when {
      margin-top: 10px;
      color: nth($colors-custom, 2);
      font-size: 12px;
      line-height: 100%;
    }
  }
}

.widget-csat-empty-state {
  margin-top: 12px;
  background: rgba(152, 193, 221, 0.08);
  border-radius: 15px;

  &--disabled {
    svg {
      fill: $blue-dark;
      stroke: none !important;
    }
  }

  svg {
    stroke: $blue-dark;
  }

  h3 {
    font-weight: 600 !important;
    line-height: 16px !important;
    color: $blue-dark;
  }

  p {
    color: $blue-dark;
  }
}
</style>
